// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"3c343b95","594":"f0630818","766":"d316fed6","970":"9d7e2953"}[chunkId] + ".chunk.js";
};